import type { IceBoardText } from '@halvard/board3d';
import { ice, squareName } from '@halvard/rules';
import type { Strings } from './en';

/** The 3D board's labels in the page's language. */
export function boardText(t: Strings): IceBoardText {
  return {
    squareLabel: (state, r, c) => {
      const h = state.heights[r]?.[c] ?? ice.HOLE;
      const parts = [squareName(r, c), h === ice.HOLE ? t.board.hole : t.board.ice(h)];
      const warrior = ice.warriorAt(state, r, c);
      if (warrior) {
        parts.push(t.warriorName(t.sides[warrior.side], t.warriors[warrior.type]));
      }
      const crack = state.cracks.find((k) => k.r === r && k.c === c);
      if (crack) parts.push(t.board.cracked(h === 0, crack.thawRound));
      const stone = ice.runestoneOf(r, c);
      const stoneName = t.runestones[stone];
      if (stoneName) parts.push(t.board.runestone(stoneName));
      return parts.join(', ');
    },
    hintLabel: (hints, r, c) => {
      const parts: string[] = [];
      if (hints.moves.some((sq) => sq.r === r && sq.c === c)) parts.push(t.board.walkHere);
      const badge = hints.badges.find((b) => b.target.r === r && b.target.c === c);
      if (badge) {
        parts.push(`${t.board.shoveHere(badge.strength, badge.wall)}${t.board.tone[badge.tone]}`);
      }
      const route = hints.routes.find(
        (x) => x.option.action.from.r === r && x.option.action.from.c === c,
      );
      if (route) parts.push(t.board.shoveFromHere);
      return parts.map((p) => `, ${p}`).join('');
    },
    sinkBadge: (reason) => t.board.sinkBadge[reason],
  };
}
